import {effectiveStaticOverlays,overlayError} from "./static-overlay-collection.js";
export const maximumOverlayPixels = 4096;
export function validateOverlay(image) {
  if (!image || Object.keys(image).sort().join(",") !== "height,rgba4444,width" || !Number.isInteger(image.width) || !Number.isInteger(image.height) ||
      image.width < 1 || image.height < 1 || image.width > 128 || image.height > 128 ||
      image.width * image.height > maximumOverlayPixels || typeof image.rgba4444 !== "string" ||
      image.rgba4444.length !== Math.ceil(image.width * image.height * 2 / 3) * 4 ||
      !/^[A-Za-z0-9+/]*={0,2}$/.test(image.rgba4444)) throw new Error("Invalid hotspot overlay image.");
  const bytes = atob(image.rgba4444);
  if (bytes.length !== image.width * image.height * 2) throw new Error("Incomplete hotspot overlay image.");
  return image;
}
export function encodeOverlay(width, height, rgba) {
  let bytes = "";
  for (let i = 0; i < width * height; i++) {
    const p = i * 4;
    bytes += String.fromCharCode((rgba[p] & 240) | (rgba[p+1] >> 4), (rgba[p+2] & 240) | (rgba[p+3] >> 4));
  }
  return validateOverlay({ width, height, rgba4444: btoa(bytes) });
}
export function decodeOverlay(image) {
  validateOverlay(image); const bytes = atob(image.rgba4444), rgba = new Uint8ClampedArray(image.width * image.height * 4);
  for (let i = 0; i < bytes.length / 2; i++) {
    const a = bytes.charCodeAt(i*2), b = bytes.charCodeAt(i*2+1);
    rgba.set([(a>>4)*17,(a&15)*17,(b>>4)*17,(b&15)*17],i*4);
  }
  return rgba;
}
export function overlayPreview(image) {
  const canvas = document.createElement("canvas");canvas.width=image.width;canvas.height=image.height;
  canvas.getContext("2d").putImageData(new ImageData(decodeOverlay(image),image.width,image.height),0,0);
  return canvas.toDataURL("image/png");
}
export function preparedOverlaySize(width,height,pixelBudget=1024) {
  if(!Number.isInteger(pixelBudget)||pixelBudget<1||pixelBudget>maximumOverlayPixels)
    throw overlayError("No overlay space remains in this playlist. Remove an overlay before adding another.");
  const scale=Math.min(1,128/width,128/height,Math.sqrt(pixelBudget/(width*height)));
  let w=Math.max(1,Math.floor(width*scale)),h=Math.max(1,Math.floor(height*scale));
  if(w*h>pixelBudget){if(w>=h)w=Math.max(1,Math.floor(pixelBudget/h));else h=Math.max(1,Math.floor(pixelBudget/w));}
  return {width:w,height:h};
}
export async function prepareOverlay(file,pixelBudget=1024) {
  if (!["image/png","image/jpeg"].includes(file.type) || file.size > 10*1024*1024) throw new Error("Choose a PNG or JPEG up to 10 MB.");
  const image=await createImageBitmap(file);
  try {
    if (image.width*image.height>32000000) throw new Error("Use an overlay image below 32 megapixels.");
    const {width,height}=preparedOverlaySize(image.width,image.height,pixelBudget);
    const canvas=document.createElement("canvas");canvas.width=width;canvas.height=height;
    const ctx=canvas.getContext("2d");ctx.drawImage(image,0,0,width,height);
    return encodeOverlay(width,height,ctx.getImageData(0,0,width,height).data);
  } finally { image.close(); }
}

export function validateOverlayPlaylist(items) {
  let pixels=0;
  for(const item of items??[])for(const area of item.interactions?.touchAreas??[]){
    if(!area.overlayImage)continue;
    validateOverlay(area.overlayImage);
    if(Number(area.coordinateMode)!==2 || item.type==="video")throw new Error("Overlay images require screen-fixed hotspots on still or scrolling artwork.");
    pixels+=area.overlayImage.width*area.overlayImage.height;
  }
  for(const item of items??[])for(const overlay of effectiveStaticOverlays(item)){validateOverlay(overlay.image);if(item.type==="video")throw overlayError("Static overlays require still or scrolling artwork.");pixels+=overlay.image.width*overlay.image.height;}
  if(pixels>4096)throw overlayError("This playlist has room for 4096 prepared overlay pixels in total. Remove an overlay or import a smaller image before adding more.");
  return pixels;
}
